import { Dayjs } from 'dayjs'

import FormDatePicker from 'components/forms/elements/FormDatePicker'
import FormSelectInput from 'components/forms/elements/FormSelectInput'
import FormTextInput from 'components/forms/elements/FormTextInput'
import { COUNTRIES, GENDERS } from 'constants/models'

const content = ({ formDisabled, updateField }) => [
  {
    id: 'firstName',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="firstName"
        label="First Name"
        required
        autoComplete="new-firstName"
        disabled={formDisabled}
      />
    ),
  },
  {
    id: 'lastName',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="lastName"
        label="Last Name"
        required
        autoComplete="new-lastName"
        disabled={formDisabled}
      />
    ),
  },
  {
    id: 'birthdate',
    size: { sm: 12, md: 4 },
    field: (
      <FormDatePicker
        name="birthdate"
        label="Birthdate"
        required
        autoComplete="new-birthdate"
        placeholder="YYYY-MM-DD"
        disabled={formDisabled}
        onModified={(value: Dayjs) => updateField('birthdate', value, true)}
      />
    ),
  },
  {
    id: 'nationality',
    size: { sm: 12, md: 4 },
    field: (
      <FormSelectInput
        name="nationality"
        label="Nationality"
        autoComplete="new-nationality"
        placeholder="Select Nationality"
        disabled={formDisabled}
        options={Object.entries(COUNTRIES).map(([key, value]) => ({
          value: key,
          text: value,
        }))}
        required
      />
    ),
  },
  {
    id: 'gender',
    size: { sm: 12, md: 4 },
    field: (
      <FormSelectInput
        name="gender"
        label="Gender"
        autoComplete="new-gender"
        placeholder="Select Gender"
        disabled={formDisabled}
        options={Object.entries(GENDERS).map(([key, value]) => ({
          value: key,
          text: value,
        }))}
        required
      />
    ),
  },
  {
    id: 'address',
    size: { sm: 12, md: 12 },
    field: (
      <FormTextInput
        name="address"
        label="Home Address"
        required
        autoComplete="new-address"
        disabled={formDisabled}
      />
    ),
  },
  {
    id: 'phoneNumber',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="phoneNumber"
        label="Phone Number"
        required
        autoComplete="new-phoneNumber"
        disabled={formDisabled}
        onCut={(e) => e.preventDefault()}
        onCopy={(e) => e.preventDefault()}
        onPaste={(e) => {
          e.preventDefault()
        }}
      />
    ),
  },
]

export default content
